import "../styles/globals.css";
import type { AppProps } from "next/app";
import App from "@view/common/App";
import * as Sentry from "@sentry/nextjs";

function MyApp({ Component, pageProps }: AppProps) {
  return (
    <Sentry.ErrorBoundary
      fallback={({ error, componentStack }) => (
        <div>
          <h1>Ha ocurrido un error inesperado</h1>
          <p>Por favor, intenta de nuevo m&aacute;s tarde.</p>
        </div>
      )}
    >
      <App>
        <Component {...pageProps} />
      </App>
    </Sentry.ErrorBoundary>
  );
}

export default MyApp
